<template>
  <div class="container" style="text-align: center; max-width: 470px; direction: ltr">
    <div class="row p-0 m-0" style="">
      <div class="col-12 p-1 order-2" style="text-align: center; font-family: IRANSansX-Regular;">
        <p style="font-size: 22px; margin: 0px; color: black" v-if="with_text">هواسترو</p>
        <p class="m-0" style="font-size: 14px; color: black" v-if="with_text">
          نرم‌افزار محاسبه چارت ودیک‌آسترولوژی
        </p>
        <!-- Display dynamic text if haveSteps is true -->
        <p class="m-0" style="font-size: 14px; color: black" v-if="is_loading">
          {{ currentLoadingText }}
        </p>
      </div>
      <div class="col-12 p-1 m-0 order-1" v-if="animated">
        <svg
          style="width: 90px"
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 109.65 115.04"
        >
          <g class="logo-name">
            <path
              d="M34.93,76.04c-1.85,0-3.46-.81-4.82-2.44-1.44-1.7-2.15-3.78-2.15-6.23,0-3.44,1.4-7.89,4.19-13.37,.3-.57,.53-.85,.68-.85,.08,.04,.11,.11,.11,.23,0,.57-.6,2.48-1.81,5.75-1.21,3.27-1.81,5.85-1.81,7.73,0,1.43,.34,2.59,1.02,3.46,.72,.94,1.72,1.42,3,1.42,2,0,4.34-1.23,7.03-3.68,.3-.26,2.66-2.81,7.08-7.65,6.5-7.03,12.31-10.54,17.45-10.54,1.47,0,2.74,.44,3.8,1.33,1.06,.89,1.59,1.94,1.59,3.14,0,1.47-.26,2.78-.79,3.91-.15,.38-.26,.57-.34,.57-.11,0-.28-.19-.51-.57-1.06-1.93-2.66-2.89-4.82-2.89-3.93,0-8.42,2.57-13.48,7.71-2.83,3.1-5.67,6.17-8.5,9.23-2.46,2.49-4.76,3.74-6.91,3.74Z"
              style="fill: #010101"
            />
            <path
              d="M36.66,35.88c0-1.77-.28-3.23-.85-4.36,0-.64,.51-2.17,1.53-4.59,.15-.3,.26-.45,.34-.45,.11,0,.25,.15,.4,.45,.3,.64,.98,2.38,2.04,5.21,1.13,2.95,1.79,4.76,1.98,5.44,.15,.53,.23,.93,.23,1.19,0,.79-.79,.3-2.38-1.47-.19-.26-.28-.15-.28,.34,0,.15,.41,5.82,1.22,17,.81,11.18,1.22,17.47,1.22,18.87,0,4.31-.64,8.08-1.93,11.33-.3,.64-.53,1.11-.68,1.42-.26,.45-.42,.53-.45,.23-.08-.34-.06-1.04,.06-2.1,.19-1.47,.28-3.19,.28-5.16,0-1.77-.45-9.05-1.36-21.84-.91-12.78-1.36-19.95-1.36-21.5Z"
              style="fill: #010101"
            />

            <path
              d="M69.63,66.19c-.27,.47-.57,.87-.91,1.2-.34,.33-.72,.6-1.13,.82,.05,.27,.07,.53,.08,.78s0,.51,0,.77c0,1-.08,1.91-.26,2.79s-.42,1.59-.74,2.28c-.32,.69-.72,1.32-1.18,1.89-.47,.57-.99,1.09-1.58,1.56-.53,.38-1.03,.68-1.52,.91-.49,.23-1.01,.43-1.56,.59-.55,.17-1.17,.32-1.84,.46-.67,.14-1.46,.3-2.35,.5-.29,.06-.56,.14-.81,.21-.25,.08-.48,.15-.69,.22-.2,.07-.37,.13-.5,.19-.13,.05-.21,.07-.25,.07-.07,0-.14,0-.19-.03-.05-.02-.08-.06-.08-.14,0-.08,.1-.18,.3-.29,.2-.12,.5-.3,.88-.54,1.44-.77,2.71-1.52,3.83-2.28,1.11-.75,2.08-1.47,2.9-2.17s1.52-1.35,2.08-1.96,1.02-1.18,1.36-1.69,.59-.96,.75-1.34,.23-.68,.23-.91c0-.17-.03-.33-.09-.5-.06-.17-.16-.35-.3-.55-.49,.11-.92,.19-1.3,.25-.38,.05-.72,.08-1.02,.08-.47,0-.88-.07-1.24-.21-.36-.14-.66-.32-.91-.55-.25-.23-.44-.49-.56-.78-.12-.29-.19-.59-.19-.89,0-.15,.02-.36,.06-.65,.04-.29,.08-.59,.14-.93,.05-.33,.09-.67,.15-1.02s.09-.66,.13-.95c.05-.42,.13-.77,.26-1.07,.13-.3,.29-.55,.48-.74,.19-.19,.42-.34,.66-.43,.25-.09,.52-.14,.8-.14,.46,0,.86,.09,1.21,.28,.35,.19,.66,.47,.93,.84,.28,.37,.53,.84,.77,1.4,.24,.56,.47,1.21,.71,1.95,.57,.1,1.07,.21,1.49,.33,.42,.12,.75,.26,1,.41Z"
              style="fill: #010101"
            />
            <path
              d="M61.08,67.29c.12-.28,.27-.54,.46-.79s.39-.48,.62-.67c.23-.19,.46-.35,.71-.46s.49-.17,.73-.17c.27,0,.58,.02,.94,.05,.36,.04,.69,.06,1,.06,.72,0,1.41-.1,2.07-.3s1.3-.47,1.91-.82,1.19-.75,1.76-1.21c.56-.46,1.1-.95,1.62-1.47v-.06c-.54-.33-.97-.82-1.28-1.47-.31-.65-.46-1.52-.46-2.63,0-.24,.02-.54,.07-.9s.12-.83,.24-1.4c.16-.79,.39-1.53,.71-2.21,.31-.68,.77-1.29,1.37-1.83,.5-.43,1-.75,1.51-.96s1.01-.31,1.5-.31c.37,0,.72,.07,1.05,.21s.62,.35,.87,.63c.25,.28,.45,.62,.59,1.02s.22,.86,.22,1.38c0,.22-.02,.48-.06,.77-.04,.29-.09,.59-.15,.91-.05,.32-.12,.64-.18,.98s-.12,.65-.17,.97l.11,.08c.46-.35,.88-.71,1.26-1.07s.7-.73,.97-1.09c.27-.36,.47-.71,.62-1.06,.15-.35,.22-.69,.22-1.01,0-.55-.1-1.14-.29-1.76-.19-.62-.49-1.26-.9-1.92-.58-.98-1.21-1.72-1.89-2.29s-1.42-.77-2.23-.77c-.96,0-1.73,.42-2.32,1.25-.58,.83-.93,2.04-1.03,3.62-.03,.31-.13,.47-.3,.47-.1,0-.18-.08-.23-.26-.05-.17-.08-.44-.08-.82s.03-.86,.09-1.4c.06-.53,.16-1.09,.29-1.65,.13-.57,.31-1.12,.52-1.67,.21-.55,.46-1.03,.76-1.45,.33-.46,.73-.83,1.2-1.12,.47-.29,1.01-.43,1.62-.43,.47,0,.95,.11,1.42,.34,.48,.23,.94,.53,1.38,.92,.44,.39,.85,.84,1.22,1.37,.38,.53,.71,1.09,.99,1.69,.28,.6,.5,1.22,.66,1.86,.16,.64,.24,1.27,.24,1.9,0,.32-.02,.73-.05,1.23s-.08,1.02-.13,1.56c-.05,.54-.13,1.06-.21,1.56-.09,.5-.19,.92-.3,1.27-.18,.6-.48,1.21-.88,1.82-.4,.61-.87,1.19-1.4,1.72s-1.11,1.01-1.73,1.42c-.62,.41-1.25,.72-1.89,.93-1.91,2.43-3.78,4.23-5.62,5.38-1.84,1.15-3.64,1.73-5.42,1.73-.49,0-.95-.03-1.39-.08-.44-.06-.84-.15-1.22-.28-.37-.13-.71-.3-1-.53-.29-.22-.54-.5-.73-.83Zm15.69-9.6c.44-.41,.79-.83,1.05-1.29,.26-.45,.39-.83,.39-1.12,0-.31-.06-.61-.17-.89s-.27-.53-.47-.75c-.2-.22-.44-.39-.73-.52-.28-.13-.59-.19-.93-.19-.49,0-.95,.09-1.39,.28-.44,.19-.83,.43-1.17,.72-.34,.29-.62,.61-.84,.96-.22,.35-.36,.68-.42,1,0,.34,.07,.65,.21,.93,.14,.28,.33,.52,.58,.73s.55,.36,.89,.47c.35,.11,.73,.17,1.14,.17,.29,0,.6-.04,.91-.13,.31-.09,.62-.21,.95-.37Z"
              style="fill: #010101"
            />
          </g>
          <g class="small-circles">
            <circle
              cx="54.83"
              cy="55.65"
              r="56"
              style="fill: transparent; stroke: none; stroke-miterlimit: 10"
            />
            <circle
              cx="54.83"
              cy="55.65"
              r="47.58"
              style="fill: none; stroke: #1d1d1b; stroke-miterlimit: 10"
            />
            <circle
              class="circle-group-1"
              cx="54.83"
              cy="1.67"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-2"
              cx="20.14"
              cy="14.3"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-1"
              cx="1.67"
              cy="46.27"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-2"
              cx="8.08"
              cy="82.63"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-1"
              cx="36.37"
              cy="106.36"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-2"
              cx="73.28"
              cy="106.36"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-1"
              cx="101.57"
              cy="82.63"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-2"
              cx="107.98"
              cy="46.28"
              r="1.67"
              style="fill: #1d1d1b"
            />
            <circle
              class="circle-group-1"
              cx="89.52"
              cy="14.3"
              r="1.67"
              style="fill: #1d1d1b"
            />
          </g>
        </svg>
      </div>
      <div class="col-12 p-1 m-0 order-1" v-if="!animated">
        <svg
          style="width: 90px"
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 109.65 115.04"
        >
          <g>
            <path
              d="M34.93,76.04c-1.85,0-3.46-.81-4.82-2.44-1.44-1.7-2.15-3.78-2.15-6.23,0-3.44,1.4-7.89,4.19-13.37,.3-.57,.53-.85,.68-.85,.08,.04,.11,.11,.11,.23,0,.57-.6,2.48-1.81,5.75-1.21,3.27-1.81,5.85-1.81,7.73,0,1.43,.34,2.59,1.02,3.46,.72,.94,1.72,1.42,3,1.42,2,0,4.34-1.23,7.03-3.68,.3-.26,2.66-2.81,7.08-7.65,6.5-7.03,12.31-10.54,17.45-10.54,1.47,0,2.74,.44,3.8,1.33,1.06,.89,1.59,1.94,1.59,3.14,0,1.47-.26,2.78-.79,3.91-.15,.38-.26,.57-.34,.57-.11,0-.28-.19-.51-.57-1.06-1.93-2.66-2.89-4.82-2.89-3.93,0-8.42,2.57-13.48,7.71-2.83,3.1-5.67,6.17-8.5,9.23-2.46,2.49-4.76,3.74-6.91,3.74Z"
              style="fill: #010101"
            />
            <path
              d="M36.66,35.88c0-1.77-.28-3.23-.85-4.36,0-.64,.51-2.17,1.53-4.59,.15-.3,.26-.45,.34-.45,.11,0,.25,.15,.4,.45,.3,.64,.98,2.38,2.04,5.21,1.13,2.95,1.79,4.76,1.98,5.44,.15,.53,.23,.93,.23,1.19,0,.79-.79,.3-2.38-1.47-.19-.26-.28-.15-.28,.34,0,.15,.41,5.82,1.22,17,.81,11.18,1.22,17.47,1.22,18.87,0,4.31-.64,8.08-1.93,11.33-.3,.64-.53,1.11-.68,1.42-.26,.45-.42,.53-.45,.23-.08-.34-.06-1.04,.06-2.1,.19-1.47,.28-3.19,.28-5.16,0-1.77-.45-9.05-1.36-21.84-.91-12.78-1.36-19.95-1.36-21.5Z"
              style="fill: #010101"
            />

            <path
              d="M69.63,66.19c-.27,.47-.57,.87-.91,1.2-.34,.33-.72,.6-1.13,.82,.05,.27,.07,.53,.08,.78s0,.51,0,.77c0,1-.08,1.91-.26,2.79s-.42,1.59-.74,2.28c-.32,.69-.72,1.32-1.18,1.89-.47,.57-.99,1.09-1.58,1.56-.53,.38-1.03,.68-1.52,.91-.49,.23-1.01,.43-1.56,.59-.55,.17-1.17,.32-1.84,.46-.67,.14-1.46,.3-2.35,.5-.29,.06-.56,.14-.81,.21-.25,.08-.48,.15-.69,.22-.2,.07-.37,.13-.5,.19-.13,.05-.21,.07-.25,.07-.07,0-.14,0-.19-.03-.05-.02-.08-.06-.08-.14,0-.08,.1-.18,.3-.29,.2-.12,.5-.3,.88-.54,1.44-.77,2.71-1.52,3.83-2.28,1.11-.75,2.08-1.47,2.9-2.17s1.52-1.35,2.08-1.96,1.02-1.18,1.36-1.69,.59-.96,.75-1.34,.23-.68,.23-.91c0-.17-.03-.33-.09-.5-.06-.17-.16-.35-.3-.55-.49,.11-.92,.19-1.3,.25-.38,.05-.72,.08-1.02,.08-.47,0-.88-.07-1.24-.21-.36-.14-.66-.32-.91-.55-.25-.23-.44-.49-.56-.78-.12-.29-.19-.59-.19-.89,0-.15,.02-.36,.06-.65,.04-.29,.08-.59,.14-.93,.05-.33,.09-.67,.15-1.02s.09-.66,.13-.95c.05-.42,.13-.77,.26-1.07,.13-.3,.29-.55,.48-.74,.19-.19,.42-.34,.66-.43,.25-.09,.52-.14,.8-.14,.46,0,.86,.09,1.21,.28,.35,.19,.66,.47,.93,.84,.28,.37,.53,.84,.77,1.4,.24,.56,.47,1.21,.71,1.95,.57,.1,1.07,.21,1.49,.33,.42,.12,.75,.26,1,.41Z"
              style="fill: #010101"
            />
            <path
              d="M61.08,67.29c.12-.28,.27-.54,.46-.79s.39-.48,.62-.67c.23-.19,.46-.35,.71-.46s.49-.17,.73-.17c.27,0,.58,.02,.94,.05,.36,.04,.69,.06,1,.06,.72,0,1.41-.1,2.07-.3s1.3-.47,1.91-.82,1.19-.75,1.76-1.21c.56-.46,1.1-.95,1.62-1.47v-.06c-.54-.33-.97-.82-1.28-1.47-.31-.65-.46-1.52-.46-2.63,0-.24,.02-.54,.07-.9s.12-.83,.24-1.4c.16-.79,.39-1.53,.71-2.21,.31-.68,.77-1.29,1.37-1.83,.5-.43,1-.75,1.51-.96s1.01-.31,1.5-.31c.37,0,.72,.07,1.05,.21s.62,.35,.87,.63c.25,.28,.45,.62,.59,1.02s.22,.86,.22,1.38c0,.22-.02,.48-.06,.77-.04,.29-.09,.59-.15,.91-.05,.32-.12,.64-.18,.98s-.12,.65-.17,.97l.11,.08c.46-.35,.88-.71,1.26-1.07s.7-.73,.97-1.09c.27-.36,.47-.71,.62-1.06,.15-.35,.22-.69,.22-1.01,0-.55-.1-1.14-.29-1.76-.19-.62-.49-1.26-.9-1.92-.58-.98-1.21-1.72-1.89-2.29s-1.42-.77-2.23-.77c-.96,0-1.73,.42-2.32,1.25-.58,.83-.93,2.04-1.03,3.62-.03,.31-.13,.47-.3,.47-.1,0-.18-.08-.23-.26-.05-.17-.08-.44-.08-.82s.03-.86,.09-1.4c.06-.53,.16-1.09,.29-1.65,.13-.57,.31-1.12,.52-1.67,.21-.55,.46-1.03,.76-1.45,.33-.46,.73-.83,1.2-1.12,.47-.29,1.01-.43,1.62-.43,.47,0,.95,.11,1.42,.34,.48,.23,.94,.53,1.38,.92,.44,.39,.85,.84,1.22,1.37,.38,.53,.71,1.09,.99,1.69,.28,.6,.5,1.22,.66,1.86,.16,.64,.24,1.27,.24,1.9,0,.32-.02,.73-.05,1.23s-.08,1.02-.13,1.56c-.05,.54-.13,1.06-.21,1.56-.09,.5-.19,.92-.3,1.27-.18,.6-.48,1.21-.88,1.82-.4,.61-.87,1.19-1.4,1.72s-1.11,1.01-1.73,1.42c-.62,.41-1.25,.72-1.89,.93-1.91,2.43-3.78,4.23-5.62,5.38-1.84,1.15-3.64,1.73-5.42,1.73-.49,0-.95-.03-1.39-.08-.44-.06-.84-.15-1.22-.28-.37-.13-.71-.3-1-.53-.29-.22-.54-.5-.73-.83Zm15.69-9.6c.44-.41,.79-.83,1.05-1.29,.26-.45,.39-.83,.39-1.12,0-.31-.06-.61-.17-.89s-.27-.53-.47-.75c-.2-.22-.44-.39-.73-.52-.28-.13-.59-.19-.93-.19-.49,0-.95,.09-1.39,.28-.44,.19-.83,.43-1.17,.72-.34,.29-.62,.61-.84,.96-.22,.35-.36,.68-.42,1,0,.34,.07,.65,.21,.93,.14,.28,.33,.52,.58,.73s.55,.36,.89,.47c.35,.11,.73,.17,1.14,.17,.29,0,.6-.04,.91-.13,.31-.09,.62-.21,.95-.37Z"
              style="fill: #010101"
            />
          </g>
          <g>
            <circle
              cx="54.83"
              cy="55.65"
              r="56"
              style="fill: transparent; stroke: none; stroke-miterlimit: 10"
            />
            <circle
              cx="54.83"
              cy="55.65"
              r="47.58"
              style="fill: none; stroke: #1d1d1b; stroke-miterlimit: 10"
            />
            <circle cx="54.83" cy="1.67" r="1.67" style="fill: #1d1d1b" />
            <circle cx="20.14" cy="14.3" r="1.67" style="fill: #1d1d1b" />
            <circle cx="1.67" cy="46.27" r="1.67" style="fill: #1d1d1b" />
            <circle cx="8.08" cy="82.63" r="1.67" style="fill: #1d1d1b" />
            <circle cx="36.37" cy="106.36" r="1.67" style="fill: #1d1d1b" />
            <circle cx="73.28" cy="106.36" r="1.67" style="fill: #1d1d1b" />
            <circle cx="101.57" cy="82.63" r="1.67" style="fill: #1d1d1b" />
            <circle cx="107.98" cy="46.28" r="1.67" style="fill: #1d1d1b" />
            <circle cx="89.52" cy="14.3" r="1.67" style="fill: #1d1d1b" />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "HoraLogo",
  props: {
    with_text: {
      type: Boolean,
      default: true,
    },
    haveSteps: {
      type: Boolean,
      default: false,
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentStepIndex: 0,
      currentLoadingText: "درحال پردازش",
      stepInterval: null,
      loadingSteps: []
    };
  },
  mounted() {

    if (this.haveSteps) {


    const rootElement = document.querySelector('.vue-loading-page');

    this.loadingSteps = [
      rootElement.getAttribute('data-text1') || "...در حال محاسبه",
      rootElement.getAttribute('data-text2') || "...در حال ترسیم چارت شما",
      rootElement.getAttribute('data-text3') || "...در حال یافتن استعداد‌های شما",
      rootElement.getAttribute('data-text4') || "...پایان محاسبات"
    ];

    this.currentLoadingText = this.loadingSteps[this.currentStepIndex];

    }
  },
  created() {
    if (this.is_loading && this.haveSteps) {
      this.startLoadingSteps();
    }
  },
  methods: {
    startLoadingSteps() {
      this.currentStepIndex = 0;
      this.currentLoadingText = this.loadingSteps[this.currentStepIndex];

      // Start interval to change text every 2.5 seconds
      this.stepInterval = setInterval(() => {
        this.currentStepIndex++;
        if (this.currentStepIndex < this.loadingSteps.length) {
          this.currentLoadingText = this.loadingSteps[this.currentStepIndex];
        } else {
          this.stopLoadingSteps(); // Stop after the last step
        }
      }, 2500);
      setTimeout(() => {
        this.stopLoadingSteps();
      }, 10000);
    },
    stopLoadingSteps() {
      var modal = document.getElementById('hora-loading');
      clearInterval(this.stepInterval);
      this.currentLoadingText = "";
      if (modal) {
        modal.remove();
      }
    },
    resetLoading() {
      clearInterval(this.stepInterval);
      this.currentLoadingText = "درحال پردازش";
    }
  },
  beforeDestroy() {
    this.resetLoading();
  },
};
</script>

<style scoped>
svg .small-circles {
  /* transform-box: fill-box; */
  transform-origin: 50% 50%;

  -webkit-animation: spin 9s linear infinite;
  -moz-animation: spin 9s linear infinite;
  animation: spin 9s linear infinite;
}

svg .circle-group-1 {
  transform-box: fill-box;
  /* transform-origin: 50% 50%; */

  -webkit-animation: circle-g1 9s linear infinite;
  -moz-animation: circle-g1 9s linear infinite;
  animation: circle-g1 9s linear infinite;
}

svg .circle-group-2 {
  transform-box: fill-box;
  /* transform-origin: 50% 50%; */

  -webkit-animation: circle-g2 9s linear infinite;
  -moz-animation: circle-g2 9s linear infinite;
  animation: circle-g2 9s linear infinite;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes circle-g1 {
  0% {
    -moz-transform: scale(0.75);
  }

  25% {
    -moz-transform: scale(1);
  }

  50% {
    -moz-transform: scale(1.25);
  }

  75% {
    -moz-transform: scale(1.5);
  }
}

@-webkit-keyframes circle-g1 {
  0% {
    -webkit-transform: scale(0.75);
  }

  25% {
    -webkit-transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.25);
  }

  75% {
    -webkit-transform: scale(1.5);
  }
}

@keyframes circle-g1 {
  0% {
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
  }

  25% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.25);
    transform: scale(1.25);
  }

  75% {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}

@-moz-keyframes circle-g2 {
  0% {
    -moz-transform: scale(1.5);
  }

  25% {
    -moz-transform: scale(1.25);
  }

  50% {
    -moz-transform: scale(1);
  }

  75% {
    -moz-transform: scale(0.75);
  }
}

@-webkit-keyframes circle-g2 {
  0% {
    -webkit-transform: scale(1.5);
  }

  25% {
    -webkit-transform: scale(1.25);
  }

  50% {
    -webkit-transform: scale(1);
  }

  75% {
    -webkit-transform: scale(0.75);
  }
}

@keyframes circle-g2 {
  0% {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }

  25% {
    -webkit-transform: scale(1.25);
    transform: scale(1.25);
  }

  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  75% {
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
  }
}
</style>
